export default "/assets/images/twilight-blue-sm.c01c0e70b0a30fd8.jpg";